import React, { useRef, useEffect, useCallback } from 'react';

const VideoPlayerWithCustomControls = React.memo(({ url, className }) => {
  const canvasRef = useRef(null);

  const videoConstraints = {
    width: 1280,
    height: 720,
    frameRate: 15,
    facingMode: 'user'
  };

  const drawFrame = useCallback((video) => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d');
      ctx.drawImage(video, 0, 0, canvasRef.current.width, canvasRef.current.height);
      requestAnimationFrame(() => drawFrame(video));
    }
  }, []);

  useEffect(() => {
    let video;
    if (url && canvasRef.current) {
      video = document.createElement('video');
      video.srcObject = url;
      video.muted = true;
      video.playsInline = true;

      video.onloadedmetadata = () => {
        video.play();
        drawFrame(video);
      };
    }

    return () => {
      if (video) {
        video.pause();
        video.srcObject = null;
      }
    };
  }, [url, drawFrame]);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      width={videoConstraints.width}
      height={videoConstraints.height}
    />
  );
});

export default VideoPlayerWithCustomControls;